import * as React from 'react';
import {translate} from 'react-i18next';
import {ITranslatedComponent} from '../../../redux/reducers/generalReducer';
import {Checkbox, CheckboxProps, Icon, Segment, Table} from "semantic-ui-react";
import {compose, Dispatch} from "redux";
import {connect} from "react-redux";
import {Link, MaintenanceDto, MenuDto, NewsDto, ResourceListOfNewsDto} from "../../../services/Client";
import AdminViewActions from "../../../redux/actions/AdminViewActions";
import HATEOASClient from "../../../services/HATEOASClient";
import NotesAndNewsHeader from "./NotesAndNewsHeader";
import NotesAndNewsRow from "./NotesAndNewsRow";
import {
    DragDropContext,
    Draggable, DraggableProvided, DraggableStateSnapshot,
    Droppable,
    DroppableProvided,
    DroppableStateSnapshot,
    DropResult
} from "react-beautiful-dnd";
import NotesAndNewsCreationDialog from "./NotesAndNewsCreationDialog";
import {reorder} from "./NotesAndNewsUtils";
import {selectNews, selectClient, selectBaseLinks} from '../../../redux/selectors';
import {IReduxState} from '../../../redux/IReduxState';
import {formatDate} from 'src/components/Table/dataHandler/Utils';
import Button from 'src/components/Button';
import MaintenanceTextUpdateDialog from './MaintenanceTextUpdateDialog';

interface IMapDispatchToProps {
    getNews: () => void;
    createNews: (links: ResourceListOfNewsDto, dto: NewsDto) => void;
    deleteNews: (dto: NewsDto) => void;
    updateNews: (dto: NewsDto) => void;
    moveNews: (dto: NewsDto, toPosition: number) => void;
}

interface IMapStateToProps {
    news: ResourceListOfNewsDto;
    client: HATEOASClient;
    baseLinks: MenuDto | undefined;
}

interface IOwnProps {

}

interface NotesAndNewsProps extends ITranslatedComponent, IOwnProps, IMapStateToProps, IMapDispatchToProps {
}

interface NotesAndNewsState {
    editMode: boolean;
    showCreationDialog: boolean;
    filterValue?: string;
    news: NewsDto[];
    selectedNews?: NewsDto;
    maintenanceText: MaintenanceDto | undefined;
    maintenanceTextContentOpen: boolean;
    showUpdateMaintenanceTextDialog: boolean;
    maintenanceTextLink: any;
}

class NotesAndNews extends React.Component<NotesAndNewsProps, NotesAndNewsState> {
    constructor(props: NotesAndNewsProps) {
        super(props);
        this.state = {
            editMode: false,
            showCreationDialog: false,
            filterValue: undefined,
            news: [],
            selectedNews: undefined,
            maintenanceText: undefined,
            maintenanceTextContentOpen: false,
            showUpdateMaintenanceTextDialog: false,
            maintenanceTextLink: undefined
        };
    }

    componentDidMount() {
        this.props.getNews();
        this.getMaintenanceText();
    }

    getMaintenanceText = () => {
        if (this.props.baseLinks) {
            this.props.client.GET_maintenanceStatus(this.props.baseLinks).execute().then((response) => {
                if (response) {
                    // @ts-ignore
                    this.setState({
                        maintenanceText: response.elements ? response.elements[0] : undefined,
                        maintenanceTextLink: response
                    });
                }
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<NotesAndNewsProps>, prevState: Readonly<NotesAndNewsState>, snapshot?: any) {
        if (prevProps.news !== this.props.news) {
            this.setState({news: this.props.news.elements ? this.props.news.elements : []});
        }
    }

    onDragEnd = (result: DropResult) => {
        // if not dropped outside the list and position different than initial
        if (result.destination && result.destination.index !== result.source.index) {
            const movedNewsDto = {...this.state.news[result.source.index]};
            const targetIndex = this.state.news[result.destination.index].sequence;
            if (movedNewsDto.sequence && targetIndex) {
                this.props.moveNews(movedNewsDto, targetIndex);

                this.setState({
                    news: reorder(this.state.news, result.source.index, result.destination.index),
                });
            }
        }
    }

    onExitDialog = (newsDto?: NewsDto) => {
        if (newsDto) {
            if (this.state.selectedNews) {
                this.props.updateNews({
                    ...this.state.selectedNews,
                    title: newsDto.title,
                    content: newsDto.content,
                    priority: newsDto.priority,
                    active: newsDto.active,
                });
            } else {
                this.props.createNews(this.props.news, newsDto);
            }
        }
        this.setState({showCreationDialog: false, selectedNews: undefined});
    }
    onExitMaintenanceTextDialog = (maintenanceDto?: MaintenanceDto) => {
        if (maintenanceDto) {
            if (this.state.maintenanceText) {
                const payload: MaintenanceDto = {
                    title: maintenanceDto.title,
                    content: maintenanceDto.content,
                    active: maintenanceDto.active,
                    objectId: maintenanceDto.objectId,
                    versionId:maintenanceDto.versionId,
                };
                if (this.state.maintenanceTextLink)
                    this.props.client.PATCH_maintenanceStatus(this.state.maintenanceTextLink).execute(payload).then((response) => {
                        if (response) {
                            this.getMaintenanceText();
                        }
                    });
            }
        }
        this.setState({showUpdateMaintenanceTextDialog: false});

    }

    onUpdateActive = (newsDto: NewsDto, active: boolean) => {
        newsDto.active = active;
        this.props.updateNews(newsDto);
    }

    public render() {
        const {
            client,
            t,
            news,
            getNews,
            deleteNews,
        } = this.props;

        const {
            news: stateNews,
            filterValue,
            editMode,
            selectedNews,
            showCreationDialog,
            maintenanceText,
            maintenanceTextContentOpen,
            showUpdateMaintenanceTextDialog
        } = this.state;

        let filteredData = filterValue
            ? stateNews.filter(item => item.title.toLowerCase().includes(filterValue.toLowerCase())
                || item.content.toLowerCase().includes(filterValue.toLowerCase()))
            : stateNews;

        const canEdit = filteredData.length > 0 && client.PATCH_news(filteredData[0]).canExecute();

        return (
            // this overflow does nothing styling wise but it fixes a bug with drag-and-drop library
            // where if there are too many items and the window gets the scrollbar
            // the list breaks after a certain point.
            <div style={{overflowY: "auto", paddingBottom: 20}}>
                {showCreationDialog &&
                    <NotesAndNewsCreationDialog
                        onExitDialog={this.onExitDialog}
                        editItem={selectedNews}
                        t={t}
                    />
                }
                {showUpdateMaintenanceTextDialog &&
                    <MaintenanceTextUpdateDialog
                        onExitDialog={this.onExitMaintenanceTextDialog}
                        editItem={maintenanceText}
                        t={t}
                    />
                }
                <NotesAndNewsHeader
                    openDialog={() => this.setState({showCreationDialog: true})}
                    onEdit={() => this.setState({editMode: !editMode})}
                    getNews={getNews}
                    onFilter={(event: React.FormEvent<{}>, newValue: string) =>
                        this.setState({filterValue: newValue !== "" ? newValue : undefined})}
                    canEdit={canEdit}
                    canCreate={client.POST_news(news).canExecute()}
                    editMode={editMode}
                    filterValue={filterValue}
                    t={t}
                />

                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
                            <table
                                className='ui celled center aligned table'
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width='10'>
                                            {t("NOTES_AND_NEWS:TITLE")} & {t("NOTES_AND_NEWS:CONTENT")}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width='1'>{t("NOTES_AND_NEWS:PRIORITY")}</Table.HeaderCell>
                                        <Table.HeaderCell width='1'>{t("NOTES_AND_NEWS:ACTIVE")}</Table.HeaderCell>
                                        <Table.HeaderCell width='1'>{t("NOTES_AND_NEWS:CREATED")}</Table.HeaderCell>
                                        <Table.HeaderCell width='1' style={{minWidth: 120}}>{t("NOTES_AND_NEWS:EDITED")}</Table.HeaderCell>
                                        <Table.HeaderCell width='2'>{t("ADMIN_VIEW:ACTIONS")}</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {filteredData && filteredData.length > 0
                                        ?
                                        filteredData.map((note, index) =>
                                            <Draggable
                                                key={note.objectId}
                                                draggableId={note.objectId.toString()}
                                                index={index}
                                                isDragDisabled={!(editMode && !filterValue)}
                                            >
                                                {(provided2: DraggableProvided, snapshot2: DraggableStateSnapshot) =>
                                                    <NotesAndNewsRow
                                                        provided={provided2}
                                                        snapshot={snapshot2}
                                                        key={note.sequence}
                                                        note={note}
                                                        client={client}
                                                        t={t}
                                                        canEdit={editMode}
                                                        onDelete={() => deleteNews(note)}
                                                        onUpdate={() => this.setState({showCreationDialog: true, selectedNews: note})}
                                                        onUpdateActive={this.onUpdateActive}
                                                    />
                                                }
                                            </Draggable>
                                        )
                                        :
                                        <Table.Row>
                                            <Table.Cell colSpan='5' style={{fontWeight: 700, fontSize: 30, color: '#d3d3d3'}}>
                                                {t('GLOBAL:NO_DATA')}
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                    {provided.placeholder}
                                </Table.Body>
                            </table>
                        )}
                    </Droppable>
                </DragDropContext>
                <Segment>
                    <h2>{t("NOTES_AND_NEWS:PRE_LAND_CONFIG")}</h2>
                    <table className='ui celled center aligned table'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width='8'>
                                    {t("NOTES_AND_NEWS:TITLE")} & {t("NOTES_AND_NEWS:CONTENT")}
                                </Table.HeaderCell>
                                <Table.HeaderCell width='1'>{t("NOTES_AND_NEWS:ACTIVE")}</Table.HeaderCell>
                                <Table.HeaderCell width='2' style={{minWidth: 120}}>{t("NOTES_AND_NEWS:EDITED")}</Table.HeaderCell>
                                <Table.HeaderCell width='2'>{t("ADMIN_VIEW:ACTIONS")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {maintenanceText && <tr>
                                <Table.Cell width='8' textAlign={'left'} className='notes-and-news-text-cell'>
                                    <div>{maintenanceText.title}</div>
                                    <div onClick={() => this.setState({maintenanceTextContentOpen: !maintenanceTextContentOpen})}>
                                        {maintenanceTextContentOpen
                                            ? maintenanceText.content
                                            : this.props.t("NOTES_AND_NEWS:CONTENT")
                                        }
                                        <div><Icon name={maintenanceTextContentOpen ? "eye slash" : "eye"} size={"big"} /></div>
                                    </div>
                                </Table.Cell>

                                <Table.Cell width='1'>
                                    <Checkbox
                                        toggle={true}
                                        disabled={true}
                                        checked={maintenanceText.active}
                                    />
                                </Table.Cell>
                                <Table.Cell width='2'>
                                    {maintenanceText.metadata && maintenanceText.metadata.changedTimestamp ? formatDate(maintenanceText.metadata.changedTimestamp) : "-"}
                                </Table.Cell>
                                <Table.Cell width='2'>
                                    <div className='display--flex flex-direction--column justify-content--center'>
                                        <Button
                                            label={t("NOTES_AND_NEWS:UPDATE")}
                                            labelPosition={"after"}
                                            icon={"pencil"}
                                            onClick={() => this.setState({showUpdateMaintenanceTextDialog: true})}
                                        />
                                    </div>
                                </Table.Cell>
                            </tr>}
                        </Table.Body>
                    </table>
                </Segment>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    news: selectNews(state),
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: NotesAndNewsProps): IMapDispatchToProps => ({
    getNews: () => dispatch(AdminViewActions.GetNews(ownProps.t)),
    createNews: (links: ResourceListOfNewsDto, dto: NewsDto) => dispatch(AdminViewActions.CreateNews(ownProps.t, links, dto)),
    deleteNews: (dto: NewsDto) => dispatch(AdminViewActions.DeleteNews(ownProps.t, dto)),
    updateNews: (dto: NewsDto) => dispatch(AdminViewActions.UpdateNews(ownProps.t, dto)),
    moveNews: (dto: NewsDto, toPosition: number) => dispatch(AdminViewActions.UpdateNewsPosition(ownProps.t, dto, toPosition)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["GLOBAL", "NOTES_AND_NEWS"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(NotesAndNews);



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/NotesAndNews.tsx